<template>
    <div class="md:py-1 rtb-header">
        <div class="business-logo invisible w-0 h-0">
            <img src="/images/aside-square-black.png" alt="logo"/>
        </div>
        <!-- Off-canvas menu for mobile -->
        <div v-if="user && sidebarOpen" class="md:hidden">
            <div
                @click="sidebarOpen = false"
                v-show="sidebarOpen"
                class="fixed inset-0 z-30 transition-opacity ease-linear duration-500"
            >
            </div>
            <div class="fixed inset-0 flex z-40">
                <div
                    v-if="user && sidebarOpen"
                    class="relative flex flex-col max-w-xs w-full bg-white min-h-screen h-fit transform ease-in-out duration-500"
                    v-click-away="onClickAway"
                >
                    <div class="grid gap-2 p-6 overflow-y-auto mb-32">
                        <div class="close-and-lang flex justify-between items-center">
                            <div class="close cursor-pointer" @click="toggleSidebar(false)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                     fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M7.88242 10.0034L13.1854 15.3074C13.4668 15.5888 13.8485 15.7469 14.2464 15.7469C14.6444 15.7469 15.026 15.5888 15.3074 15.3074C15.5888 15.026 15.7469 14.6444 15.7469 14.2464C15.7469 13.8485 15.5888 13.4668 15.3074 13.1854L10.0024 7.88243L15.3064 2.57943C15.4457 2.4401 15.5561 2.2747 15.6315 2.09268C15.7068 1.91066 15.7456 1.71558 15.7455 1.51858C15.7455 1.32158 15.7066 1.12652 15.6312 0.944534C15.5558 0.762548 15.4452 0.597201 15.3059 0.457934C15.1666 0.318668 15.0012 0.208208 14.8192 0.132863C14.6371 0.057517 14.4421 0.0187609 14.2451 0.0188074C14.0481 0.0188538 13.853 0.0577016 13.671 0.133133C13.489 0.208564 13.3237 0.319102 13.1844 0.458435L7.88242 5.76143L2.57942 0.458435C2.44111 0.315105 2.27565 0.200756 2.09268 0.122057C1.90971 0.0433583 1.7129 0.00188689 1.51374 6.29038e-05C1.31457 -0.00176108 1.11703 0.0360986 0.932653 0.111433C0.748274 0.186767 0.580745 0.298068 0.43984 0.43884C0.298935 0.579612 0.187477 0.747037 0.111969 0.931345C0.0364604 1.11565 -0.00158556 1.31315 5.06168e-05 1.51232C0.00168679 1.71149 0.0429722 1.90834 0.121498 2.09138C0.200024 2.27443 0.314218 2.44 0.457417 2.57843L5.76242 7.88243L0.458417 13.1854C0.177022 13.4668 0.0189362 13.8485 0.0189362 14.2464C0.0189362 14.6444 0.177022 15.026 0.458417 15.3074C0.739812 15.5888 1.12146 15.7469 1.51942 15.7469C1.91737 15.7469 2.29902 15.5888 2.58042 15.3074L7.88242 10.0024V10.0034Z"
                                          fill="#D71920"/>
                                </svg>
                            </div>
                            <div class="mid-line"></div>
                            <div class="language-switch px-3 py-2">
                                <SwitchLang/>
                            </div>
                        </div>

                        <div class="user-profile border border-gray-300 rounded mb-1 p-2 cursor-pointer" @click="$router.push('/customer/profile')">
                            <div class="user-icon-name flex items-center gap-3">
                                <div class="image">
                                    <img class="w-10 h-10 rounded flex items-start justify-center"
                                         :src="user?.profile?.photo"
                                         alt="user">
                                </div>
                                <div class="user-name-email grid">
                                    <div class="name font-bold text-base">
                                        <p>{{ user?.name }}</p>
                                    </div>
                                    <div class="email">
                                        <p>{{ user?.email ?? 'example@test.com' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="menu-item my-profile flex justify-between gap-5 gap-y-3 items-center cursor-pointer"
                             @click="$router.push('/customer/profile')">
                            <div class="icon flex justify-start items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.83333 5.66667C6.83333 4.95942 7.11428 4.28115 7.61438 3.78105C8.11448 3.28095 8.79276 3 9.5 3C10.2072 3 10.8855 3.28095 11.3856 3.78105C11.8857 4.28115 12.1667 4.95942 12.1667 5.66667C12.1667 6.37391 11.8857 7.05219 11.3856 7.55229C10.8855 8.05238 10.2072 8.33333 9.5 8.33333C8.79276 8.33333 8.11448 8.05238 7.61438 7.55229C7.11428 7.05219 6.83333 6.37391 6.83333 5.66667ZM6.83333 9.66667C5.94928 9.66667 5.10143 10.0179 4.47631 10.643C3.85119 11.2681 3.5 12.1159 3.5 13C3.5 13.5304 3.71071 14.0391 4.08579 14.4142C4.46086 14.7893 4.96957 15 5.5 15H13.5C14.0304 15 14.5391 14.7893 14.9142 14.4142C15.2893 14.0391 15.5 13.5304 15.5 13C15.5 12.1159 15.1488 11.2681 14.5237 10.643C13.8986 10.0179 13.0507 9.66667 12.1667 9.66667H6.83333Z" fill="#D71920"/>
                                </svg>
                                <div class="title text-sm font-semibold">
                                    <p>আমার প্রোফাইল</p>
                                </div>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72007 5.22032C8.8607 5.07987 9.05132 5.00098 9.25007 5.00098C9.44882 5.00098 9.63945 5.07987 9.78007 5.22032L14.0301 9.47032C14.1705 9.61094 14.2494 9.80157 14.2494 10.0003C14.2494 10.1991 14.1705 10.3897 14.0301 10.5303L9.78007 14.7803C9.6379 14.9128 9.44985 14.9849 9.25555 14.9815C9.06125 14.9781 8.87586 14.8994 8.73845 14.7619C8.60104 14.6245 8.52233 14.4391 8.5189 14.2448C8.51547 14.0505 8.58759 13.8625 8.72007 13.7203L12.4401 10.0003L8.72007 6.28032C8.57962 6.13969 8.50073 5.94907 8.50073 5.75032C8.50073 5.55157 8.57962 5.36094 8.72007 5.22032Z" fill="#9D9D9D"/>
                            </svg>
                        </div>

                        <div class="menu-item my-profile flex justify-between gap-5 gap-y-3 items-center cursor-pointer"
                             @click="$router.push('/trips')">
                            <div class="icon flex justify-start items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M4.22565 6.504L3.86854 4.99697C3.83969 4.87597 3.7873 4.76184 3.71435 4.6611C3.6414 4.56035 3.54933 4.47496 3.44338 4.4098C3.33743 4.34463 3.21968 4.30098 3.09686 4.28132C2.97403 4.26166 2.84854 4.26639 2.72755 4.29523C2.60655 4.32408 2.49242 4.37647 2.39168 4.44942C2.29093 4.52237 2.20554 4.61444 2.14038 4.72039C2.07521 4.82634 2.03156 4.94409 2.0119 5.06691C1.99225 5.18974 1.99697 5.31523 2.02581 5.43622L2.9686 9.33236C3.02789 9.57469 3.18047 9.7838 3.39314 9.91421C3.60581 10.0446 3.86137 10.0858 4.10423 10.0287L8.00394 9.09666C9.23243 8.79669 8.78603 6.95397 7.55755 7.25394L5.68269 7.70748C6.67733 6.45185 8.02326 5.52074 9.54899 5.03281C11.0747 4.54487 12.7112 4.52219 14.2498 4.96767C15.7885 5.41314 17.1597 6.30659 18.1888 7.53419C19.2178 8.76178 19.8581 10.2679 20.0281 11.8607C20.1316 13.1535 22.0886 12.9428 21.9101 11.6572C21.3637 6.53614 17.0069 2.72214 11.4537 2.7757C8.19679 3.09711 5.82911 4.49701 4.22565 6.504ZM15.9819 15.8747C14.7034 16.139 15.1641 18.0639 16.4212 17.7175L18.296 17.2639C17.3037 18.5241 15.9579 19.4595 14.431 19.9505C12.904 20.4415 11.2653 20.4657 9.72444 20.0201C8.18361 19.5745 6.81077 18.6793 5.78157 17.4491C4.75238 16.2189 4.11365 14.7095 3.9471 13.1142C3.94078 12.9854 3.9082 12.8592 3.85136 12.7435C3.79451 12.6277 3.71461 12.5248 3.61654 12.441C3.51847 12.3572 3.40432 12.2944 3.28109 12.2563C3.15786 12.2183 3.02815 12.2058 2.89992 12.2197C2.7717 12.2336 2.64767 12.2736 2.53545 12.3371C2.42323 12.4007 2.32519 12.4865 2.24734 12.5894C2.1695 12.6922 2.11349 12.8099 2.08277 12.9351C2.05204 13.0604 2.04724 13.1906 2.06867 13.3178C2.35288 15.9435 3.66649 18.3494 5.72159 20.0082C7.77668 21.667 10.4056 22.4434 13.0321 22.1671C14.3411 22.0263 15.609 21.6267 16.7622 20.9915C17.9154 20.3564 18.9308 19.4984 19.7495 18.4674L20.1138 19.978C20.3459 21.2993 22.3422 20.8208 21.9493 19.5388L21.0173 15.639C20.9101 15.1891 20.4959 14.882 19.9531 14.9248L15.9819 15.8747Z" fill="#D71920"/>
                                </svg>
                                <div class="title text-sm font-semibold">
                                    <p>হিস্ট্রি</p>
                                </div>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72007 5.22032C8.8607 5.07987 9.05132 5.00098 9.25007 5.00098C9.44882 5.00098 9.63945 5.07987 9.78007 5.22032L14.0301 9.47032C14.1705 9.61094 14.2494 9.80157 14.2494 10.0003C14.2494 10.1991 14.1705 10.3897 14.0301 10.5303L9.78007 14.7803C9.6379 14.9128 9.44985 14.9849 9.25555 14.9815C9.06125 14.9781 8.87586 14.8994 8.73845 14.7619C8.60104 14.6245 8.52233 14.4391 8.5189 14.2448C8.51547 14.0505 8.58759 13.8625 8.72007 13.7203L12.4401 10.0003L8.72007 6.28032C8.57962 6.13969 8.50073 5.94907 8.50073 5.75032C8.50073 5.55157 8.57962 5.36094 8.72007 5.22032Z" fill="#9D9D9D"/>
                            </svg>
                        </div>

                        <div class="menu-item contact flex justify-between gap-5 items-center cursor-pointer"
                             @click="$router.push('/contact')">
                            <div class="icon flex justify-start items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                    <path d="M16.2436 9.13659C16.2652 9.6556 16.0817 10.162 15.7336 10.5448C15.3854 10.9275 14.901 11.1554 14.3866 11.1783C14.3565 11.1797 14.3264 11.1804 14.2965 11.1804C14.1598 11.1803 14.0235 11.1654 13.89 11.1359C13.4938 11.7529 12.9743 12.2798 12.3647 12.6828C11.7551 13.0857 11.0688 13.3559 10.3498 13.476C10.2648 13.728 10.0951 13.9422 9.87016 14.0814C9.6452 14.2206 9.37909 14.2762 9.11783 14.2385C8.85657 14.2008 8.61658 14.0722 8.43934 13.8749C8.2621 13.6777 8.15875 13.4241 8.14716 13.1582C8.13557 12.8922 8.21646 12.6305 8.37586 12.4183C8.53526 12.2061 8.76314 12.0567 9.02011 11.9961C9.27709 11.9354 9.547 11.9672 9.7832 12.0859C10.0194 12.2047 10.207 12.403 10.3137 12.6466C11.326 12.4577 12.2404 11.9165 12.8978 11.1173C13.5551 10.3181 13.9135 9.3115 13.9106 8.27303C13.9106 5.81965 11.932 3.8237 9.5 3.8237C7.06795 3.8237 5.08935 5.81965 5.08935 8.27303C5.08922 9.03166 5.28141 9.77771 5.64767 10.4403C5.66008 10.4622 5.6694 10.4857 5.67535 10.5101C5.71073 10.6093 5.70695 10.7184 5.66479 10.8149C5.62263 10.9114 5.54533 10.9878 5.44887 11.0283C5.21269 11.1286 4.95902 11.1802 4.70278 11.1802C4.67262 11.1802 4.6424 11.1795 4.61211 11.1781C4.09788 11.1549 3.61375 10.9269 3.26588 10.5442C2.918 10.1615 2.73478 9.6552 2.75638 9.1364C2.76506 8.92952 2.76021 8.74493 2.75548 8.56643C2.75107 8.39837 2.74647 8.22457 2.75403 8.04322C2.77662 7.53666 2.99262 7.05856 3.35682 6.70907C3.72101 6.35957 4.20513 6.16578 4.70778 6.16829C5.51496 4.30531 7.35905 3 9.5 3C11.641 3 13.4851 4.30531 14.2922 6.16832C14.7949 6.16543 15.2792 6.35905 15.6435 6.70855C16.0077 7.05806 16.2237 7.53629 16.2459 8.04292C16.2535 8.22454 16.249 8.39831 16.2445 8.56638C16.2398 8.7449 16.2349 8.92957 16.2436 9.13659ZM12.9241 8.27303C12.9239 8.80221 12.8033 9.32428 12.5714 9.79897C12.3396 10.2737 12.0027 10.6883 11.5869 11.0109C11.1711 11.3335 10.6873 11.5554 10.173 11.6596C9.6587 11.7638 9.12753 11.7474 8.62048 11.6117L7.23452 12.4192C7.16459 12.4599 7.08426 12.4788 7.00368 12.4735C6.92309 12.4682 6.84589 12.4388 6.78182 12.3893C6.71775 12.3397 6.6697 12.272 6.64375 12.1949C6.61779 12.1177 6.6151 12.0346 6.636 11.9559L6.99022 10.6229C6.40362 9.98332 6.07723 9.14438 6.076 8.27303C6.076 6.36788 7.61193 4.81806 9.5 4.81806C11.3881 4.81806 12.9241 6.36788 12.9241 8.27303ZM8.54806 8.27303C8.54806 8.1638 8.50504 8.05905 8.42848 7.98181C8.35191 7.90457 8.24807 7.86118 8.13979 7.86118H8.13911C8.05839 7.86133 7.97953 7.88562 7.9125 7.93096C7.84546 7.97631 7.79325 8.04069 7.76246 8.11595C7.73168 8.19122 7.7237 8.27401 7.73954 8.35385C7.75538 8.43369 7.79432 8.507 7.85145 8.56452C7.90858 8.62204 7.98133 8.66119 8.0605 8.67702C8.13968 8.69285 8.22173 8.68465 8.29628 8.65345C8.37084 8.62226 8.43456 8.56947 8.47939 8.50176C8.52421 8.43405 8.54814 8.35445 8.54814 8.27303H8.54806ZM9.90835 8.27303C9.90832 8.25955 9.90759 8.24608 9.90617 8.23267C9.90489 8.21921 9.9029 8.20583 9.90021 8.19258C9.89777 8.17939 9.89449 8.16636 9.89039 8.15359C9.8866 8.14069 9.88198 8.12806 9.87708 8.11543C9.87218 8.1028 9.86619 8.09099 9.85993 8.07919C9.85371 8.06731 9.8469 8.05577 9.83952 8.04459C9.83207 8.0333 9.82407 8.02239 9.81554 8.01192C9.80715 8.00142 9.79816 7.99143 9.78862 7.98199C9.77936 7.97238 9.76929 7.96332 9.75895 7.95453C9.74858 7.9463 9.73769 7.93806 9.72653 7.93065C9.71547 7.9232 9.70403 7.91633 9.69227 7.91005C9.68054 7.90374 9.66832 7.89797 9.65604 7.89276C9.64378 7.88758 9.63125 7.88309 9.61851 7.8793C9.59305 7.87106 9.56676 7.86571 9.54012 7.86338C9.50013 7.85949 9.4598 7.86144 9.42036 7.86914C9.40723 7.87185 9.39425 7.87524 9.38147 7.8793C9.36871 7.88308 9.35617 7.88757 9.34391 7.89276C9.33166 7.89797 9.31941 7.90374 9.30771 7.91005C9.296 7.91637 9.28457 7.92323 9.27338 7.93065C9.25104 7.9456 9.23026 7.96281 9.21136 7.98199C9.2018 7.99144 9.1928 8.00143 9.18438 8.01192C9.17595 8.0224 9.16806 8.0333 9.16073 8.04459C9.15325 8.05576 9.14635 8.0673 9.14004 8.07919C9.13376 8.09095 9.12812 8.10305 9.12314 8.11543C9.11798 8.12791 9.11343 8.14065 9.10953 8.15359C9.10575 8.16622 9.10248 8.1794 9.09976 8.19258C9.09707 8.20583 9.09507 8.21921 9.09375 8.23267C9.09241 8.24612 9.09184 8.25958 9.09184 8.27303C9.09184 8.28648 9.09241 8.30021 9.09375 8.31367C9.09509 8.32703 9.09709 8.34032 9.09976 8.35348C9.10248 8.36666 9.10575 8.37984 9.10953 8.39274C9.11343 8.40559 9.11798 8.41824 9.12314 8.43063C9.12812 8.4431 9.13376 8.45529 9.14004 8.46715C9.14628 8.47895 9.15338 8.49049 9.16073 8.50174C9.16806 8.51294 9.17596 8.52376 9.18438 8.53414C9.19286 8.54466 9.20187 8.55474 9.21136 8.56434C9.22088 8.57368 9.23068 8.58301 9.24129 8.59153C9.25153 8.6001 9.26224 8.60808 9.27338 8.61541C9.28457 8.62283 9.29598 8.62997 9.30771 8.63628C9.33134 8.64871 9.35603 8.659 9.38147 8.66703C9.39423 8.67088 9.4073 8.67417 9.42036 8.67692C9.4466 8.68233 9.47333 8.685 9.50011 8.68488C9.60826 8.68459 9.71193 8.64128 9.78862 8.56434C9.80743 8.54508 9.82447 8.52413 9.83952 8.50174C9.84686 8.49049 9.85367 8.47895 9.85993 8.46715C9.86619 8.45534 9.8719 8.44299 9.87708 8.43063C9.88225 8.41827 9.8866 8.40537 9.89039 8.39274C9.89446 8.37987 9.89774 8.36676 9.90021 8.35348C9.90288 8.34032 9.90487 8.32703 9.90617 8.31367C9.90756 8.30015 9.90826 8.28657 9.90827 8.27298L9.90835 8.27303ZM11.2692 8.27303C11.2692 8.1638 11.2262 8.05905 11.1497 7.98181C11.0731 7.90457 10.9693 7.86118 10.861 7.86118H10.8602C10.7795 7.86134 10.7006 7.88563 10.6336 7.93098C10.5665 7.97633 10.5143 8.0407 10.4836 8.11597C10.4528 8.19124 10.4448 8.27403 10.4606 8.35386C10.4765 8.4337 10.5154 8.50701 10.5726 8.56453C10.6297 8.62205 10.7024 8.66119 10.7816 8.67702C10.8608 8.69285 10.9428 8.68465 11.0174 8.65345C11.0919 8.62226 11.1557 8.56947 11.2005 8.50176C11.2453 8.43405 11.2692 8.35445 11.2692 8.27303Z" fill="#D71920"/>
                                </svg>

                                <div class="title text-sm font-semibold">
                                    <p>যোগাযোগ</p>
                                </div>
                            </div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72007 5.22032C8.8607 5.07987 9.05132 5.00098 9.25007 5.00098C9.44882 5.00098 9.63945 5.07987 9.78007 5.22032L14.0301 9.47032C14.1705 9.61094 14.2494 9.80157 14.2494 10.0003C14.2494 10.1991 14.1705 10.3897 14.0301 10.5303L9.78007 14.7803C9.6379 14.9128 9.44985 14.9849 9.25555 14.9815C9.06125 14.9781 8.87586 14.8994 8.73845 14.7619C8.60104 14.6245 8.52233 14.4391 8.5189 14.2448C8.51547 14.0505 8.58759 13.8625 8.72007 13.7203L12.4401 10.0003L8.72007 6.28032C8.57962 6.13969 8.50073 5.94907 8.50073 5.75032C8.50073 5.55157 8.57962 5.36094 8.72007 5.22032Z" fill="#9D9D9D"/>
                            </svg>
                        </div>
                        <div class="menu-item contact flex justify-between gap-5 items-center cursor-pointer"
                             @click="$router.push('/about')">
                            <div class="icon flex justify-start items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" stroke="#D71920" stroke-width="2" stroke-linecap="round"
                                     stroke-linejoin="round" class="feather feather-info">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>

                                <div class="title text-sm font-semibold">
                                    <p>আমাদের সম্পর্কে </p>
                                </div>
                            </div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72007 5.22032C8.8607 5.07987 9.05132 5.00098 9.25007 5.00098C9.44882 5.00098 9.63945 5.07987 9.78007 5.22032L14.0301 9.47032C14.1705 9.61094 14.2494 9.80157 14.2494 10.0003C14.2494 10.1991 14.1705 10.3897 14.0301 10.5303L9.78007 14.7803C9.6379 14.9128 9.44985 14.9849 9.25555 14.9815C9.06125 14.9781 8.87586 14.8994 8.73845 14.7619C8.60104 14.6245 8.52233 14.4391 8.5189 14.2448C8.51547 14.0505 8.58759 13.8625 8.72007 13.7203L12.4401 10.0003L8.72007 6.28032C8.57962 6.13969 8.50073 5.94907 8.50073 5.75032C8.50073 5.55157 8.57962 5.36094 8.72007 5.22032Z" fill="#9D9D9D"/>
                            </svg>
                        </div>
                        <div class="menu-item help-line flex justify-between gap-5 items-center cursor-pointer"
                             @click="$router.push('/help')">
                            <div class="icon flex justify-start gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                    <path d="M14.8091 9.23164L14.5668 9.08507C14.2785 8.91102 14.1062 8.59859 14.1062 8.25C14.1062 7.90141 14.2785 7.58898 14.5668 7.41493L14.8091 7.26836C14.9663 7.17343 15.104 7.047 15.2145 6.89632C15.325 6.74563 15.4061 6.57362 15.453 6.39014C15.5 6.20665 15.5119 6.01527 15.4882 5.82694C15.4645 5.63861 15.4056 5.45702 15.3148 5.29254L14.8542 4.45746C14.6707 4.12555 14.3689 3.8834 14.0151 3.78415C13.6612 3.6849 13.2842 3.73666 12.9668 3.92807L12.7245 4.07416C12.5848 4.1599 12.4259 4.20509 12.2639 4.20509C12.102 4.20509 11.943 4.1599 11.8034 4.07416C11.6627 3.99029 11.5459 3.86873 11.4649 3.72197C11.384 3.57522 11.3418 3.40855 11.3428 3.23909V2.94643C11.3428 2.14896 10.7228 1.5 9.96105 1.5H9.0399C8.2781 1.5 7.65817 2.14896 7.65817 2.94643V3.23957C7.65911 3.40903 7.61694 3.5757 7.536 3.72246C7.45506 3.86921 7.33826 3.99077 7.19759 4.07464C7.05787 4.16023 6.8989 4.20534 6.73701 4.20534C6.57513 4.20534 6.41616 4.16023 6.27644 4.07464L6.03417 3.92807C5.71663 3.73677 5.33959 3.68507 4.9857 3.78431C4.63181 3.88354 4.32994 4.12562 4.14627 4.45746L3.68569 5.29254C3.59485 5.457 3.53587 5.6386 3.51212 5.82694C3.48837 6.01528 3.50032 6.20668 3.54729 6.39019C3.59426 6.57369 3.67532 6.74571 3.78584 6.89639C3.89637 7.04707 4.03418 7.17347 4.19141 7.26836L4.43413 7.41493C4.72245 7.58898 4.89471 7.90141 4.89471 8.25C4.89471 8.59859 4.72245 8.91102 4.43413 9.08507L4.19187 9.23164C4.03464 9.32653 3.89683 9.45293 3.78631 9.60361C3.67578 9.75429 3.59472 9.92631 3.54775 10.1098C3.50078 10.2933 3.48883 10.4847 3.51258 10.6731C3.53633 10.8614 3.59531 11.043 3.68615 11.2075L4.14673 12.0425C4.33031 12.3744 4.6321 12.6164 4.98591 12.7157C5.33973 12.8149 5.7167 12.7632 6.03417 12.5719L6.27644 12.4258C6.41611 12.3401 6.5751 12.2949 6.73701 12.2949C6.89893 12.2949 7.05792 12.3401 7.19759 12.4258C7.33826 12.5097 7.45506 12.6313 7.536 12.778C7.61694 12.9248 7.65911 13.0915 7.65817 13.2609V13.5536C7.65817 14.351 8.2781 15 9.0399 15H9.96105C10.7228 15 11.3428 14.351 11.3428 13.5536V13.2604C11.3428 12.9118 11.515 12.5999 11.8034 12.4254C11.9431 12.3398 12.102 12.2947 12.2639 12.2947C12.4258 12.2947 12.5848 12.3398 12.7245 12.4254L12.9668 12.5719C13.2843 12.7631 13.6612 12.8147 14.015 12.7155C14.3688 12.6162 14.6706 12.3743 14.8542 12.0425L15.3148 11.2075C15.4056 11.043 15.4646 10.8614 15.4884 10.6731C15.5121 10.4847 15.5002 10.2933 15.4532 10.1098C15.4062 9.92631 15.3252 9.75429 15.2146 9.60361C15.1041 9.45293 14.9663 9.32653 14.8091 9.23164ZM9.50047 10.6607C8.23066 10.6607 7.19759 9.57927 7.19759 8.25C7.19759 6.92073 8.23066 5.83929 9.50047 5.83929C10.7703 5.83929 11.8034 6.92073 11.8034 8.25C11.8034 9.57927 10.7703 10.6607 9.50047 10.6607Z" fill="#D71920"/>
                                </svg>
                                <div class="title text-sm font-semibold">
                                    <p>সেটিংস</p>
                                </div>
                            </div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72007 5.22032C8.8607 5.07987 9.05132 5.00098 9.25007 5.00098C9.44882 5.00098 9.63945 5.07987 9.78007 5.22032L14.0301 9.47032C14.1705 9.61094 14.2494 9.80157 14.2494 10.0003C14.2494 10.1991 14.1705 10.3897 14.0301 10.5303L9.78007 14.7803C9.6379 14.9128 9.44985 14.9849 9.25555 14.9815C9.06125 14.9781 8.87586 14.8994 8.73845 14.7619C8.60104 14.6245 8.52233 14.4391 8.5189 14.2448C8.51547 14.0505 8.58759 13.8625 8.72007 13.7203L12.4401 10.0003L8.72007 6.28032C8.57962 6.13969 8.50073 5.94907 8.50073 5.75032C8.50073 5.55157 8.57962 5.36094 8.72007 5.22032Z" fill="#9D9D9D"/>
                            </svg>
                        </div>


                        <div
                            class="logout-rtb h-10 w-4/5  px-5 flex gap-4 items-center justify-center absolute left-0 right-0 bottom-5 mx-auto cursor-pointer"
                            v-if="user"
                            @click="logOut()"
                        >
                            <span class="text-white text-sm font-semibold">লগ আউট</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19"
                                 fill="none">
                                <path
                                    d="M18.4412 9.49989H8.38235M16.3235 12.6764L19.5 9.49989L16.3235 6.32341M11.0294 4.20577V3.14694C11.0294 2.58531 10.8063 2.04668 10.4092 1.64954C10.012 1.25241 9.4734 1.0293 8.91177 1.0293H3.61765C3.05601 1.0293 2.51738 1.25241 2.12024 1.64954C1.72311 2.04668 1.5 2.58531 1.5 3.14694V15.8528C1.5 16.4145 1.72311 16.9531 2.12024 17.3502C2.51738 17.7474 3.05601 17.9705 3.61765 17.9705H8.91177C9.4734 17.9705 10.012 17.7474 10.4092 17.3502C10.8063 16.9531 11.0294 16.4145 11.0294 15.8528V14.794"
                                    stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-shrink-0 w-24" @click="sidebarOpen = false">
                <!-- Force sidebar to shrink to fit close icon -->
            </div>
        </div>
    </div>
    <!-- Off-canvas menu for mobile -->
    <!-- Menubar for desktop -->
    <div class="w-full md:flex hidden h-24 shadow mb-2">
        <div class="w-full max-w-7xl mx-auto flex justify-between ">
            <div class="flex justify-start items-center">
                <router-link to="/">
                    <img class="w-40" src="/images/aside-square-black.png" alt="return trip bd"/>
                </router-link>
            </div>

            <div class="flex justify-end items-center">

                <div
                    class="flex mr-3 items-center relative signin-signup-wrapper"
                    v-if="!user"
                >
                    <!--<button
                        @click="$router.push('/signup')"
                        class="text-white ml-1 py-2 px-3 rounded-md header-signin-signup"
                    >
                        {{ $t("card.signIn") }}
                    </button>-->
                    <!--<div class="absolute text-sm text-gray-700 flex signup-section">
                        New User?
                        <span
                            class="signup colored-primary cursor-pointer"
                            @click="$router.push('/signup')"
                        >
                            {{ $t("card.signUp") }}
                        </span>
                    </div>-->
                </div>

                <div class="relative" v-if="user">
                    <AccountDropdown
                        @onClickAccountDropdown="onClickAccountDropdown"
                        :userType="userType"
                    />
                </div>
            </div>

        </div>
    </div>
    <!-- Menubar for desktop -->
    <!-- Hamburger -->
    <div
        class="md:hidden mobile-header h-16 px-4 flex items-center"
        :class="user ? 'justify-between' : 'justify-start mobile-header-bg-white'"
    >
        <div v-if="!user">
            <div
                v-if="$route.name !== 'BeforeSignin'"
                @click="$router.go(-1)"
                class="flex items-center justify-center cursor-pointer"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path d="M16 2C13.2311 2 10.5243 2.82109 8.22202 4.35943C5.91973 5.89777 4.12532 8.08427 3.06569 10.6424C2.00607 13.2006 1.72882 16.0155 2.26901 18.7313C2.80921 21.447 4.14258 23.9416 6.10051 25.8995C8.05845 27.8574 10.553 29.1908 13.2687 29.731C15.9845 30.2712 18.7994 29.9939 21.3576 28.9343C23.9157 27.8747 26.1022 26.0803 27.6406 23.778C29.1789 21.4757 30 18.7689 30 16C30 12.287 28.525 8.72601 25.8995 6.1005C23.274 3.475 19.713 2 16 2ZM24 17H11.85L17.43 22.573L16 24L8.00001 16L16 8L17.43 9.393L11.85 15H24V17Z" fill="#D71920"/>
                </svg>
            </div>
        </div>
        <div v-if="$route.name === 'TripBidding' && user ">
            <div
                @click="$router.go(-1)"
                class="flex items-center justify-center cursor-pointer h-6 w-6 bg-white rounded-full"
            >
                <span class="mdi mdi-arrow-left mdi-24px text-red-700"></span>
            </div>
        </div>
            <div
                v-if="user && $route.name !== 'TripBidding'"
                @click.stop="toggleSidebar(true)"
                class="-mt-1"
                :class="[user ? 'cursor-pointer': 'cursor-not-allowed']"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                        d="M24.6 13.5H5.4C4.572 13.5 4.5 14.1705 4.5 15C4.5 15.8295 4.572 16.5 5.4 16.5H24.6C25.428 16.5 25.5 15.8295 25.5 15C25.5 14.1705 25.428 13.5 24.6 13.5ZM24.6 19.5H5.4C4.572 19.5 4.5 20.1705 4.5 21C4.5 21.8295 4.572 22.5 5.4 22.5H24.6C25.428 22.5 25.5 21.8295 25.5 21C25.5 20.1705 25.428 19.5 24.6 19.5ZM5.4 10.5H24.6C25.428 10.5 25.5 9.8295 25.5 9C25.5 8.1705 25.428 7.5 24.6 7.5H5.4C4.572 7.5 4.5 8.1705 4.5 9C4.5 9.8295 4.572 10.5 5.4 10.5Z"
                        fill="white"/>
                </svg>
            </div>
            <router-link v-if="user" to="/" class="rtb-title flex items-center text-xl font-bold">
                {{ $route.name === 'TripBidding' ? "বিড সমূহ" : "রিটার্ন ট্রিপ" }}
            </router-link>
            <div class="flex gap-2 items-center">
                <div
                    v-if="user"
                    @click="viewNotification()"
                    class="notification-bell relative flex justify-center cursor-pointer"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path
                            d="M17.9383 22C17.9385 22.5046 17.7479 22.9906 17.4048 23.3605C17.0617 23.7305 16.5915 23.9572 16.0883 23.995L15.9383 24H13.9383C13.4337 24.0002 12.9478 23.8096 12.5778 23.4665C12.2078 23.1234 11.9812 22.6532 11.9433 22.15L11.9383 22H17.9383ZM14.9383 5C16.7533 4.99997 18.4973 5.70489 19.8026 6.96607C21.1078 8.22726 21.8721 9.94609 21.9343 11.76L21.9383 12V15.764L23.7603 19.408C23.8398 19.567 23.8796 19.7429 23.8763 19.9206C23.873 20.0984 23.8266 20.2727 23.7412 20.4286C23.6558 20.5845 23.5338 20.7174 23.3858 20.8158C23.2378 20.9143 23.0681 20.9754 22.8913 20.994L22.7763 21H7.10033C6.92249 21.0001 6.74729 20.957 6.58975 20.8745C6.4322 20.792 6.297 20.6725 6.19574 20.5264C6.09448 20.3802 6.03017 20.2116 6.00833 20.0351C5.98649 19.8586 6.00776 19.6795 6.07033 19.513L6.11633 19.408L7.93833 15.764V12C7.93833 10.1435 8.67582 8.36301 9.98858 7.05025C11.3013 5.7375 13.0818 5 14.9383 5Z"
                            fill="white"/>
                    </svg>
                    <sup
                        v-if="notifications.length > 0"
                        class="count text-gray-700 text-sm mt-2 -ml-2"
                    >
                        {{ notifications.length > 9 ? "9+" : notifications.length }}
                    </sup>
                </div>
            </div>
        </div>
        <!-- Hamburger -->
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import AccountDropdown from "@/components/molecule/auth/AccountDropdown";
import {menus} from "@/data/menu";
import SwitchLang from "@/components/atom/SwitchLang";
import Form from "@/services/form";
import axios from "axios";
import {clearDeviceInterests} from "@/services/clearDeviceInterests";
import {directive} from "vue3-click-away";

export default {
    name: "Header",
    components: {
        AccountDropdown,
        SwitchLang,
    },

    data() {
        return {
            isLoggingOut: false,
            notifications: [],
            form: new Form(),
            navClass: [
                "px-4",
                "font-semibold",
                "hover:text-primary",
                "text-gray-700",
                "text-sm",
            ],
            mobileNav:
                "group flex items-center px-2 py-2 mb-2 text-base leading-6 font-medium rounded-md text-black focus:outline-none focus:bg-gray-700 transition ease-in-out duration-150",
            menus,
            signin: true,
        };
    },
    directives: {
        ClickAway: directive
    },

    computed: {
        ...mapGetters({
            user: "user/getUser",
            sidebarOpen: "getSidebarStatus",
        }),

        userType() {
            return this.user ? this.user?.type : false;
        },
    },

    methods: {
        ...mapMutations({
            setUserInfo: "user/setLoggedInUser",
            setDialogComponent: "setDialogComponent",
            setSidebarStatus: "setSidebarStatus",
            setDialog: "setDialog",
        }),
        navigate(link) {
            this.setSidebarStatus(false);
            this.$router.push(link);
        },
        handleDialog(name) {
            this.setSidebarStatus(false);
            this.setDialogComponent(name);
        },
        onClickAccountDropdown() {
            this.setSidebarStatus(false);
        },

        toggleSidebar(value) {
            this.setSidebarStatus(value);
        },
        async logOut() {
            localStorage.removeItem("trip_auth_user");
            localStorage.removeItem("token");
            localStorage.removeItem("imp_token");
            clearDeviceInterests();
            this.isLoggingOut = true;
            try {
                await this.form.post("auth/logout");
            } catch (err) {
                if (err.response) {
                }
            } finally {
                this.setUserInfo(null);
                this.$router.push("/signup");
            }
        },
        viewNotification() {
            this.$router.push("/notifications");
        },
        getNotifications(url) {
            axios.get(url).then((res) => {
                this.notifications = res.data.data.data;
            });
        },

        onClickAway() {
            if (this.sidebarOpen) {
                this.toggleSidebar(!this.sidebarOpen)
            }
        }
    }, //end of methods
    mounted() {
        let url = "notifications/unseen";
        if (this.user) {
            this.getNotifications(url);
        }
    },
    props: {
        logo: {
            default: "/images/aside-square-black.png",
        },
    },

    created() {
        this.setUserInfo();
    },

    watch: {
        $route: function () {
            this.setSidebarStatus(false);
            this.setDialog(false);
        },
    },
};
</script>

<style scoped lang="scss">
.rtb-header {
    background: #fff;
    @apply shadow-lg md:hidden block;
    font-family: 'Noto Sans Bengali';
}

.mobile-menu-item {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
    background: #F4F4F4;
}

.signin-signup-wrapper {
    min-width: 130px;
    display: grid;
    justify-content: flex-end;
}

.header-signin-signup {
    background-color: #D71920;
    min-width: 120px;
}

.colored-primary {
    color: #ff4365;
}

.signup {
    font-weight: bold;
}

.signup-section {
    font-size: 12px !important;
    gap: 5px;
    bottom: -20px !important;
}

.vertical-menu-dots {
    max-height: 24px;
    max-width: 24px;
}

.vsc-popup-button--default {
    background-color: #69c157 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.vsc-popup {
    bottom: 50px !important;
}

.vsc-popup-button {
    height: 40px !important;
    width: 40px !important;
}

.vsc-popup-button:focus,
.vsc-popup-button:hover {
    box-shadow: none !important;
}

.max-width {
    max-width: 1260px;
}

.contact-us p {
    border-bottom: 3px solid #000;
    max-width: fit-content;
    padding-right: 10px;
    padding-bottom: 2px;
}

.mobile-header {
    font-family: 'Noto Sans Bengali';
    background: #D72028;

    .rtb-title {
        color: #ffffff;
    }
}

.mobile-header-bg-white {
    background: #F8FAFC;
}

.mid-line {
    height: 2px;
    width: 100%;
    margin: 0 10px;
    border-radius: 10px;
    background: #BBC6D0;
}

.user-name-email {
    color: #3A3A3A;

    .email {
        font-size: 12px;
        font-weight: 400;
    }
}

.title {
    font-family: 'Noto Sans Bengali', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #1A1A1A;
}
.menu-item {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
    background: #F4F4F4;
}

.logout-rtb {
    border-radius: 10px;
    background: #D71920;
}

@media (min-width: 640px) {
    .notification-bell svg {
        height: 30px;
        width: 30px;

        path {
            fill: gray;
        }
    }
}
</style>
